"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author VRu
 */

var ValueWithUnitConverter =
/*#__PURE__*/
function () {
  function ValueWithUnitConverter() {
    _classCallCheck(this, ValueWithUnitConverter);
  }

  _createClass(ValueWithUnitConverter, null, [{
    key: "deserialize",
    value: function deserialize(conversions) {
      return function (document) {
        return {
          value: conversions.toBigNumber(document.value),
          unitId: conversions.asObject(document, 'unitId', function (value) {
            return conversions.toClassReferenceId(value);
          })
        };
      };
    }
  }, {
    key: "serialize",
    value: function serialize(conversions) {
      return function (object) {
        return {
          value: conversions.fromBigNumber(object.value),
          unitId: conversions.toDocumentReferenceId(object.unitId)
        };
      };
    }
  }]);

  return ValueWithUnitConverter;
}();

exports.ValueWithUnitConverter = ValueWithUnitConverter;